module.exports = __webpack_public_path__ + "assets/4e4a1cb5639dc681dc02461ee8a66789.mp3";